import React, {memo, forwardRef} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {SelectChangeEvent} from "@mui/material"
import {TextModel} from "models/Text"
import connect from "./connect"
import {Sorting} from "../../../models/Sorting"

export interface SelectSortProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    value: string | undefined
    onChange: (event: SelectChangeEvent<any>) => void
    open: boolean
    toggleDropdown: () => void
    sortOptions: Sorting | undefined
    text: TextModel
}

export const SelectSort = memo(
    forwardRef(function SelectSort(
        {templating, onChange, open, toggleDropdown, value, sortOptions, text}: SelectSortProps,
        ref,
    ) {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)

        return (
            <ComponentName
                aria-label={text.labels.sortMenu}
                sortOptions={sortOptions}
                onChange={onChange}
                disableUnderline
                open={open}
                toggleDropdown={toggleDropdown}
                ref={ref}
                value={value}
            />
        )
    }),
)
SelectSort.displayName = "SelectSort"

export default connect(SelectSort)
